import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import Select from "react-select";
import MediaGroupService from "../../../services/KangarooServices/MediaGroupService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import MediaGroupForm from "../component/MediaGroupForm";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CategoryList = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showColumnChooser, setShowColumnChooser] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // Filter states
  const [filters, setFilters] = useState({
    name: "",
    Status: null,
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [categoryType, setCategoryType] = useState("category");

  // Delete modal states
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = (item) => {
    setSelectedDeleteItem(item);
    setIsOpen(!isOpen);
  };
  const columns = [
    {
      name: "S.N",
      selector: (row) => row.index,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,

      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.description || "None",
    },
    {
      name: "Media Count",
      selector: (row) => row.mediaCount || "None",
      sortable: true,

      wrap: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <ButtonGroup size="sm">
            {/* <Link to={`/category-detail/${row.id}`}>
              <Button color="btn btn-soft-success" className="btn-sm">
                <i className="bx bx-show" />
              </Button>
            </Link> */}

            <Button
              color="btn btn-soft-warning"
              className="btn-sm gap-1 ms-1"
              size="sm"
              onClick={() => toggleModal(row)}
            >
              <i className="ri-edit-line" />
            </Button>

            <Button
              className="btn btn-soft-danger btn-sm gap-1 ms-1"
              color="danger"
              onClick={() => handleDeleteClick(row)}
              size="sm"
            >
              <i className="ri-delete-bin-5-line" />
            </Button>
          </ButtonGroup>
        </div>
      ),
      center: true,
    },
  ];

  const fetchCategories = async (
    pageNumber = 1,
    size = pageSize,
    currentFilters = debouncedFilters
  ) => {
    try {
      setLoading(true);
      const response = await MediaGroupService.getList({
        ...currentFilters,
        pageNumber,
        pageSize: size,
      });

      const indexedData = response.items.map((item, index) => ({
        ...item,
        index: (pageNumber - 1) * size + index + 1,
        parentName: null, // or fetch parent category if needed
      }));

      setCategoryList(indexedData);
      setTotalRows(response.totalCount);
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.error("Failed to fetch categories");
    } finally {
      setLoading(false);
    }
  };

  // Debounce filter changes
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1); // Reset to first page when filters change
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  // Update IsCatering filter based on categoryType
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      IsCatering: categoryType === "catering" ? true : null,
    }));
  }, [categoryType]);

  // Fetch data when page, size, or filters change
  useEffect(() => {
    fetchCategories(currentPage, pageSize);
  }, [currentPage, pageSize, debouncedFilters]);

  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, name: e.target.value }));
  };

  // Delete modal handlers
  const toggleDelete = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await MediaGroupService.delete(selectedDeleteItem.id);
        fetchCategories(currentPage, pageSize);
        toast.success("Selected Item deleted successfully");
      } catch (error) {
        console.error("Error deleting Item:", error);
        toast.error(
          error?.response?.data?.message || "Failed to delete Item"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };
  const toggleColumnChooser = () => setShowColumnChooser(!showColumnChooser);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* <BreadCrumb title="Category List" pageTitle="Category Management" /> */}
        <BreadCrumb title="Media Group" pageTitle="Media Management" />
      </div>

      <Row className="">
        <Col xs={12} lg={4} className="mb-2 ">
          <InputGroup>
            <Input
              placeholder="Search by name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>

        <Col xs={5} lg={5}>
          <button className="btn btn-success " onClick={() => toggleModal()}>
            + Add Category
          </button>
        </Col>
      </Row>
      <div className="d-lg-block d-md-block d-none">
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          paginationServer
          paginationTotalRows={totalRows}
          paginationDefaultPage={currentPage}
          paginationPerPage={pageSize}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressComponent={
            <div className="my-3">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={categoryList}
        />
      </div>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
      <MediaGroupForm
        isOpen={isOpen}
        toggle={toggleModal}
        selectedItem={selectedDeleteItem}
        fetchCategories={fetchCategories}
      />
    </div>
  );
};

export default CategoryList;
